import React from 'react';
import logo from '../routes/logo.svg';
import { Card } from './ui/card';
/** Shared account-entry branding, also used before a farm has been accepted. */
export default function AccountEntry({ children }: { children: React.ReactNode }) {
  return <main className="shadcn-scope login-page">
    <section className="login-intro" aria-label="AgriWorks LMS">
      <div className="login-brand"><img src={logo} alt="" /><span>AgriWorks LMS<span className="brand-caption">Livestock Management System</span></span></div>
      <div className="login-intro-copy"><p className="login-eyebrow">YOUR HERD. YOUR WORKING DAY.</p><h1>A clearer picture<br />of your herd.</h1><p>Animal records, scoring and the details that matter — together in one place.</p></div>
      <p className="login-intro-foot">Built around life on the farm.</p>
    </section>
    <section className="login-form-area" aria-label="Account access"><Card className="login-card">{children}</Card><a className="login-update" href="/app-update.html">Check for app updates</a></section>
  </main>;
}
